import { ReportsTranslations } from "../models/reports-translaction-model";

export const ptBR: ReportsTranslations = {
  filter: {
    period: 'Período',
    dates: 'Datas',
    expandSearch: 'Expandir Opções de Pesquisa',
    financialGroup: 'Grupo Financeiro',
    status: 'Status',
    clear: 'Limpar Filtros',
    search: 'Pesquisar',
    placeholders: {
      select: 'Selecione',
    },
    dateOptions: {
      lastSevenDays: 'Últimos 7 dias',
      lastThirtyDays: 'Últimos 30 dias',
      lastThreeMonths: 'Últimos 3 meses',
      currentMonth: 'Mês Atual',
      custom: 'Personalizado',
      noDate: 'Nenhuma Seleção de Data',
    },
    snackbar: {
      fillField: 'Preencha um campo',
    },
    buttons: {
      cancel: 'Cancelar',
      ok: 'OK',
    },
  },
  table: {
    noData: 'Nenhum dado encontrado.',
    tooltipError: 'Erro no relatório',
    headers: {
      reportLayout: 'Layout de Relatório',
      reportName: 'Nome do arquivo',
      financialGroup: 'Grupo Financeiro',
      requestedBy: 'Solicitado por',
      requestDate: 'Data da Solicitação',
      issueDate: 'Data da Emissão',
      status: 'Status',
      error: 'Erro',
      actions: 'Ações',
    },
  },
  messages: {
    downloadSuccess: 'Download realizado com sucesso.',
    downloadError: 'Ocorreu um erro ao tentar efetuar o download.',
    fetchError: 'Ocorreu um erro ao buscar os relatórios.',
    noDataText: 'Nenhum dado encontrado.',
    loadingText: 'Carregando...',
    noResultText: 'Nenhum resultado encontrado.',
  },
  errorModal: {
    title: 'Erro nos relatórios',
    headers: {
      description: 'Descrição do Erro',
      date: 'Data',
    },
  },
  status: {
    requested: 'Solicitado',
    processing: 'Em Processamento',
    fail: 'Erro na Emissão',
    success: 'Emitido com Sucesso',
  },
  reportLayouts: {
    reportMovementRecordDefault: 'Relatório Movimentação Cadastral Padrão',
    reportMovementRecordAnalytical: 'Relatório Movimentação Cadastral Analítico',
    reportMovementRecordOperational: 'Relatório Movimentação Cadastral Operacional',
    reportFileDataErrors: 'Relatório de Erros',
    reportFileDataCorrectionFile: 'Arquivo de Correção',
    reportFileDataCriticismReturn: 'Arquivo de Retorno de Críticas',
  },
  defaults: {
    reportLayoutName: 'Arquivo de Beneficiário',
  },
};
